import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2, Mail, KeyRound } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [state, setState] = useState({ status: "loading" });
  const tries = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id");
    if (!sid) { setState({ status: "error" }); return; }

    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState({ ...data, status: "paid" }); return; }
      } catch { /* keep trying */ }
      tries.current += 1;
      if (tries.current > 20) { setState({ status: "timeout" }); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-xuma-bg grid place-items-center px-5">
      <div className="max-w-md w-full text-center">
        {state.status === "loading" && (
          <><Loader2 className="h-10 w-10 animate-spin text-xuma-primary mx-auto" />
          <p className="mt-4 text-xuma-muted">Confirmando tu pago...</p></>
        )}

        {state.status === "paid" && (
          <div className="rounded-3xl bg-white border border-xuma-border p-10" data-testid="payment-success">
            <div className="h-16 w-16 rounded-full bg-xuma-primary grid place-items-center mx-auto text-white"><CheckCircle2 className="h-8 w-8" /></div>
            <h1 className="mt-6 font-heading font-extrabold text-2xl text-xuma-dark">¡Pago confirmado! 🎉</h1>
            {state.email_sent ? (
              <p className="mt-3 text-xuma-muted flex items-center justify-center gap-2">
                <Mail className="h-4 w-4 text-xuma-primary" /> Te enviamos un correo a <b>{state.email}</b> con tu enlace y contraseña.
              </p>
            ) : (
              <div className="mt-4 rounded-2xl bg-xuma-dash p-4 text-left">
                <p className="text-sm text-xuma-dark flex items-center gap-2"><KeyRound className="h-4 w-4 text-xuma-primary" /> Tus accesos:</p>
                <p className="text-sm mt-2"><b>Usuario:</b> {state.email}</p>
                <p className="text-sm"><b>Contraseña provisional:</b> {state.provisional_password}</p>
                <p className="text-xs text-xuma-muted mt-2">Deberás cambiarla al iniciar sesión.</p>
              </div>
            )}
            <Link to="/login"><button data-testid="go-login-btn" className="mt-6 h-12 px-8 rounded-full bg-xuma-primary hover:bg-xuma-primaryHover text-white font-medium">Entrar a mi panel</button></Link>
          </div>
        )}

        {(state.status === "error" || state.status === "timeout") && (
          <div className="rounded-3xl bg-white border border-xuma-border p-10">
            <h1 className="font-heading font-extrabold text-2xl text-xuma-dark">Estamos procesando tu pago</h1>
            <p className="mt-3 text-xuma-muted">Si ya pagaste, revisa tu correo en unos minutos o intenta iniciar sesión.</p>
            <Link to="/login"><button className="mt-6 h-12 px-8 rounded-full bg-xuma-primary text-white font-medium">Ir a iniciar sesión</button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
